import {KebabHorizontalIcon} from '@primer/octicons-react'

export function HunkKebabIcon() {
  return (
    /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
    <div className="hunk-kebab-icon pr-2 pb-1">
      <KebabHorizontalIcon />
    </div>
  )
}
